/*
 * Page Title (Figma 119:11048; padding 32px instead of 48px for density, 2026-10-03): padding 32px, bottom 1px --border-default, column gap 6,
 * clipped, with the header Pattern.
 * Title: Heading XL — 550, 28px, line-height 1.21, tracking -0.42px (-1.5%), --text-default.
 * Description: 400 14/20 --text-weak.
 * Narrow screens (not in Figma): the sides are the page gutter (--layout-page-padding-x), 24px top
 * and bottom on a phone, and a long title or description wraps (a word too long for the line breaks).
 */
import type { ReactNode } from 'react'
import { Pattern } from './Pattern'

export function PageTitle({ title, description }: { title: string; description?: ReactNode }) {
    return (
        <header className="relative flex w-full flex-col items-start gap-[6px] overflow-clip border-b border-solid border-[var(--border-default)] px-[var(--layout-page-padding-x)] py-[32px] max-sm:py-[24px]">
            <div className="relative flex max-w-full min-w-0 flex-col items-start gap-[6px]">
                <h1 className="m-0 text-[28px] leading-[1.21] font-[550] tracking-[-0.42px] [overflow-wrap:anywhere] text-[var(--text-default)]">{title}</h1>
                {description && <div className="flex max-w-full items-center text-[14px] leading-[20px] font-normal [overflow-wrap:anywhere] text-[var(--text-weak)]">{description}</div>}
            </div>
            <Pattern variant="header" />
        </header>
    )
}
